<ng-container *ngIf="fieldValue" >

  <div class="d-flex w-100 h-100 align-items-center gap-1" [matTooltip]="fieldValue || ''">
    <img *ngIf="imagePath && !iconMissing" [src]="imagePath" [alt]="fieldValue || ''" (error)="onIconError()" width="24" height="24" >
    <span class="d-flex" style="font-size: 0.8125rem">{{ fieldValue }}</span>
  </div>

</ng-container>
